module.exports = __webpack_public_path__ + "static/media/krishan.40ccbfc7.jpg";